import {
  Box,
  Button,
  Dialog,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

import { Close } from "@mui/icons-material";

interface EndLessonDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

function EndLessonDialog({
  open,
  onClose,
  onConfirm,
}: EndLessonDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      aria-labelledby="end-lesson-dialog-title"
      slotProps={{
        paper: {
          sx: {
            maxWidth: 440,
            px: 4,
            py: 4,
          },
        },
      }}
    >
      <IconButton
        aria-label="Close end lesson dialog"
        onClick={onClose}
        sx={{
          position: "absolute",
          top: -24,
          right: -24,
          color: "common.white",
        }}
      >
        <Close />
      </IconButton>

      <Stack spacing={3} alignItems="center">
        <Box>
          <Typography
            component="span"
            sx={{
              fontFamily: "SourceSerif4",
              fontWeight: 500,
              fontStyle: "italic",
              fontSize: 44,
              lineHeight: "44px",
            }}
          >
            🛑
          </Typography>
        </Box>

        <Stack spacing={1} alignItems="center" sx={{ maxWidth: 320 }}>
          <Typography
            variant="h2Serif"
          >
            End lesson?
          </Typography>
          <Typography variant="text13L" align="center" >
            Are you sure you want to end this lesson? This action cannot be undone.
          </Typography>
        </Stack>

        <Stack direction="row" gap={1} justifyContent="center" width="100%">
          <Button variant="contained" color="primary" fullWidth onClick={onClose}>
            Return to lesson
          </Button>
          <Button
            variant="outlined"
            color="error"
            fullWidth
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            End Lesson
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  );
}

export default EndLessonDialog;
